import {DashboardWidget} from 'common/src/modules/dashboards/dashboards.types';
import _maxBy from 'lodash/maxBy';
import {NUMBER_OF_COLUMNS} from '../dashboards.constants';

function getNewWidgetX(widgets: DashboardWidget[], newWidgetWidth: number) {
  let lastWidgetXPosition = 0;
  let lastWidgetWidth = 0;

  const lastRowLayoutInLastColumn = _maxBy(
    widgets,
    ({layout}) => layout.x + (layout.h + layout.y) * NUMBER_OF_COLUMNS,
  )?.layout;

  if (lastRowLayoutInLastColumn) {
    const {x, w} = lastRowLayoutInLastColumn;
    lastWidgetXPosition = x;
    lastWidgetWidth = w;
  }

  return lastWidgetXPosition + lastWidgetWidth + newWidgetWidth <= NUMBER_OF_COLUMNS
    ? lastWidgetXPosition + lastWidgetWidth
    : 0;
}

function getNewWidgetY(widgets: DashboardWidget[], x: number) {
  let lastWidgetYPosition = 0;
  let lastWidgetHeight = 0;

  const lastRowLayoutByMaxHeight = _maxBy(widgets, ({layout}) => layout.y + layout.h)?.layout;

  if (lastRowLayoutByMaxHeight) {
    const {y, h} = lastRowLayoutByMaxHeight;
    lastWidgetYPosition = y;
    lastWidgetHeight = h;
  }

  return !x && lastRowLayoutByMaxHeight
    ? lastWidgetYPosition + lastWidgetHeight
    : lastWidgetYPosition;
}

export default function getNewItemPosition(widgets: DashboardWidget[], newWidgetWidth: number) {
  const x = getNewWidgetX(widgets, newWidgetWidth);
  const y = getNewWidgetY(widgets, x);

  return {x, y};
}
